import ApiService from "@/core/services/ApiService"
import moment from "moment/moment";
import { useToast } from "vue-toastification";
const toast = useToast();
import store from "@/store";
import lodash from "lodash";

// Cache için global değişkenler
let moduleListCache = null;
let moduleControlCache = {};
let moduleListPromise = null; // Devam eden istek için promise cache

async function currencyList(paramObject = {}) {
    return await new Promise(resolve => {
        ApiService.getParams("admin/currency", { params: paramObject }).then(({ data }) => {
            resolve(data);
        }).catch(({ response }) => {
            resolve([]);
        })
    })
}

function priceFormat(price) {
    const currency = store.getters.currentUser?.data?.companyId?.currency || { name: 'TRY', locale: 'tr-TR' };

    const formattedPrice = new Intl.NumberFormat(currency.locale, { style: 'currency', currency: currency.name }).format(price);
    return formattedPrice;
}

async function listLocations(paramObject = {}) {
    return await new Promise(resolve => {
        ApiService.getParams("admin/locations", { params: paramObject }).then(({ data }) => {
            resolve(data.data);
        }).catch(({ response }) => {
            resolve([]);
        })
    })
}

async function listUsers(paramObject = {}) {
    return await new Promise(resolve => {
        ApiService.getParams("admin/users", { params: paramObject }).then(({ data }) => {
            resolve(data.data);
        }).catch(({ response }) => {
            resolve([]);
        })
    })
}

async function fuelTypeList(paramObject = {}) {
    return await new Promise(resolve => {
        ApiService.getParams("admin/fueltype", { params: paramObject }).then(({ data }) => {
            resolve(data);
        }).catch(({ response }) => {
            resolve([]);
        })
    })
}

async function fuelLevelList(paramObject = {}) {
    return await new Promise(resolve => {
        ApiService.getParams("admin/fuellevel", { params: paramObject }).then(({ data }) => {
            resolve(data);
        }).catch(({ response }) => {
            resolve([]);
        })
    })
}

async function deliveryLists(paramObject = {}) {
    return await new Promise(resolve => {
        ApiService.getParams("admin/deliverys", { params: paramObject }).then(({ data }) => {
            resolve(lodash.orderBy(data.data, ["_id"], ["desc"]));
        }).catch(({ response }) => {
            resolve([]);
        })
    })
}

async function deliveryList(paramObject = {}) {
    return await new Promise(resolve => {
        ApiService.getParams("admin/delivery", { params: paramObject }).then(({ data }) => {
            resolve(data.data);
        }).catch(({ response }) => {
            resolve([]);
        })
    })
}

async function serviceLists(paramObject = {}) {
    return await new Promise(resolve => {
        ApiService.getParams("admin/services", { params: paramObject }).then(({ data }) => {
            resolve(lodash.orderBy(data.data, ["_id"], ["desc"]));
        }).catch(({ response }) => {
            resolve([]);
        })
    })
}

async function vehicleLists(paramObject = {}, method = 'get') {
    return await new Promise(resolve => {
        let request;
        if (method === 'post') {
            request = ApiService.post("admin/vehicles", paramObject);
        } else {
            request = ApiService.getParams("admin/vehicles", { params: paramObject });
        }

        request.then(({ data }) => {
            resolve(data.data);
        }).catch(({ response }) => {
            resolve([]);
        })
    })
}

async function vehicleList(paramObject = {}) {
    return await new Promise(resolve => {
        ApiService.getParams("admin/vehicle", { params: paramObject }).then(({ data }) => {
            resolve(data.data);
        }).catch(({ response }) => {
            resolve(null);
        })
    })
}

async function partDamageList(paramObject = {}) {
    return await new Promise(resolve => {
        ApiService.getParams("admin/damage-types", { params: paramObject }).then(({ data }) => {
            resolve(data.data);
        }).catch(({ response }) => {
            resolve([]);
        })
    })
}

async function vehiclePartList(paramObject = {}) {
    return await new Promise(resolve => {
        ApiService.getParams("admin/vehicle-parts", { params: paramObject }).then(({ data }) => {
            resolve(data);
        }).catch(({ response }) => {
            resolve([]);
        })
    })
}

async function vehicleDamageSketch(paramObject = {}) {
    return await new Promise(resolve => {
        ApiService.getParams("admin/damage-sketch", { params: paramObject }).then(({ data }) => {
            resolve(data.data);
        }).catch(({ response }) => {
            resolve([]);
        })
    })
}

async function vehiclePhotos(paramObject = {}) {
    return await new Promise(resolve => {
        ApiService.getParams("admin/photos", { params: paramObject }).then(({ data }) => {
            resolve(data.data);
        }).catch(({ response }) => {
            resolve([]);
        })
    })
}

async function vehiclePartsPhotosList(paramObject = {}) {
    return await new Promise(resolve => {
        ApiService.getParams("admin/part-photo-areas", { params: paramObject }).then(({ data }) => {
            resolve(data.data);
        }).catch(({ response }) => {
            resolve([]);
        })
    })
}

async function deliveryContractLists(paramObject = {}) {
    return await new Promise(resolve => {
        ApiService.getParams("admin/delivery-contracts", { params: paramObject }).then(({ data }) => {
            resolve(data.data);
        }).catch(({ response }) => {
            resolve([]);
        })
    })
}

async function deliveryContractList(paramObject = {}) {
    return await new Promise(resolve => {
        ApiService.getParams("admin/delivery-contract", { params: paramObject }).then(({ data }) => {
            resolve(data.data);
        }).catch(({ response }) => {
            resolve(null);
        })
    })
}

async function damagePhotoList(paramsObject = {}) {
    return await new Promise(resolve => {
        ApiService.getParams("admin/photos", { params: paramsObject }).then(({ data }) => {
            resolve(data);
        }).catch(({ response }) => {
            resolve([]);
        })
    })
}

async function damageList(paramsObject = {}) {
    return await new Promise(resolve => {
        ApiService.getParams("admin/damages", { params: paramsObject }).then(({ data }) => {
            resolve(data.data);
        }).catch(({ response }) => {
            resolve([]);
        })
    })
}

async function getDamage(paramsObject = {}) {
    return await new Promise(resolve => {
        ApiService.getParams("admin/damage", { params: paramsObject }).then(({ data }) => {
            resolve(data.data);
        }).catch(({ response }) => {
            resolve(null);
        })
    })
}

async function transmissionList(paramsObject = {}) {
    return await new Promise(resolve => {
        ApiService.getParams("admin/transmission", { params: paramsObject }).then(({ data }) => {
            resolve(data);
        }).catch(({ response }) => {
            resolve([]);
        })
    })
}

async function deliveryReturnTypeList(paramsObject = {}) {
    return await new Promise(resolve => {
        ApiService.getParams("admin/delivery-return-types", { params: paramsObject }).then(({ data }) => {
            resolve(data.data);
        }).catch(({ response }) => {
            resolve([]);
        })
    })
}

async function deliveryTypeList(paramsObject = {}) {
    return await new Promise(resolve => {
        ApiService.getParams("admin/delivery-types", { params: paramsObject }).then(({ data }) => {
            resolve(data.data);
        }).catch(({ response }) => {
            resolve([]);
        })
    })
}

async function serviceCancelOptions(paramsObject = {}) {
    return await new Promise(resolve => {
        ApiService.getParams("admin/service-cancel-options", { params: paramsObject }).then(({ data }) => {
            resolve(data.data);
        }).catch(({ response }) => {
            resolve([]);
        })
    })
}

async function serviceTypes(paramsObject = {}) {
    return await new Promise(resolve => {
        ApiService.getParams("admin/service-types", { params: paramsObject }).then(({ data }) => {
            resolve(data.data);
        }).catch(({ response }) => {
            resolve([]);
        })
    })
}

async function mainContractControl(identityNumber) {
    if (!identityNumber) return;

    return await new Promise(resolve => {
        ApiService.getParams("admin/delivery-contract", {
            params: {
                contractType: "mainContract",
                identityNumber: identityNumber,
                nowTime: moment().add(1, "minutes").format("YYYY-MM-DD HH:mm:ss")
            }
        }).then(({ data }) => {
            resolve(data.data);
        }).catch(({ response }) => {
            resolve(null);
        })
    })
}

async function getAuthSchema() {
    return await new Promise(resolve => {
        ApiService.get('admin/authSchema').then(response => {
            resolve(response.data);
        }).finally(() => {
            resolve(null);
        });
    });
}

async function getAuthList(paramsObject = {}) {
    return await new Promise(resolve => {
        ApiService.getParams("admin/authority-groups", { params: paramsObject }).then(({ data }) => {
            resolve(data.data);
        }).catch(({ response }) => {
            resolve([]);
        })
    })
}

async function logList(paramsObject = {}) {
    return await new Promise(resolve => {
        ApiService.getParams("admin/logs", { params: paramsObject }).then(({ data }) => {
            resolve(data.data);
        }).catch(({ response }) => {
            resolve([]);
        })
    })
}

async function fileList(paramsObject = {}) {
    return await new Promise(resolve => {
        ApiService.getParams("admin/file-managements", { params: paramsObject }).then(({ data }) => {
            resolve(data.data);
        }).catch(({ response }) => {
            resolve([]);
        })
    })
}

async function paymentLists(paramsObject = {}) {
    return await new Promise(resolve => {
        ApiService.getParams("admin/payments", { params: paramsObject }).then(({ data }) => {
            resolve(data.data);
        }).catch(({ response }) => {
            resolve([]);
        })
    })
}

async function paymentList(paramsObject = {}) {
    return await new Promise(resolve => {
        ApiService.getParams("admin/payment", { params: paramsObject }).then(({ data }) => {
            resolve(data.data);
        }).catch(({ response }) => {
            resolve(null);
        })
    })
}

function authControl(authName, childrenName) {
    if (Object.keys(store.state.AuthModule.user).length > 0) {
        if (authName && childrenName) {
            if (store.getters.currentUser?.data?.auth?.auth && store.getters.currentUser?.data?.auth?.auth[authName] && store.getters.currentUser?.data?.auth?.auth[authName].children) {
                if (store.getters.currentUser.data.auth.auth[authName].children[childrenName]) {
                    return true;
                } else {
                    return false;
                }
            } else {
                return false;
            }
        }
    }
    return false;
}

function subsAuthControl(type, subs) {
    var sonuc = false;

    if (type === 'single') {
        if (authControl(subs.meta.authName, subs.meta.children)) {
            sonuc = true;
        }
    } else {
        if (subs.length > 0) {
            for (let i = 0; i < subs.length; i++) {
                const sub = subs[i];

                if (authControl(sub.meta.authName, sub.meta.children)) {
                    sonuc = true;
                    break;
                }
            }
        }
    }

    return sonuc;
}

function convertBytes(bytes, decimals = 1) {
    if (!+bytes) return '0 Bytes'

    const k = 1024
    const dm = decimals < 0 ? 0 : decimals
    const sizes = ['bytes', 'KB', 'MB', 'GB']

    const i = Math.floor(Math.log(bytes) / Math.log(k))

    return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`

}

function dateDiff(startDate, endDate) {
    // milisaniye cinsinden farkı hesaplama
    var zaman_farki = moment(moment(endDate)).diff(moment(startDate), 'miliseconds');

    var saniye_farki = (zaman_farki / 1000) % 60;
    var dakika_farki = (zaman_farki / (1000 * 60)) % 60;
    var saat_farki = (zaman_farki / (1000 * 60 * 60)) % 24;
    // var yil_farki    = (zaman_farki  / (1000l * 60 * 60 * 24 * 365));
    var gun_farki = (zaman_farki / (1000 * 60 * 60 * 24)) % 365;

    var data = {
        milisecond: Math.floor(zaman_farki),
        day: Math.floor(gun_farki),
        hour: Math.floor(saat_farki),
        minute: Math.floor(dakika_farki),
        second: Math.floor(saniye_farki),
    };

    return data;
}

async function dealerLists(paramsObject = {}) {
    return await new Promise(resolve => {
        ApiService.getParams("admin/dealers", { params: paramsObject }).then(({ data }) => {
            resolve(data.data);
        }).catch(({ response }) => {
            resolve([]);
        })
    })
}

async function extrasList(paramsObject = {}) {
    return await new Promise(resolve => {
        ApiService.getParams("admin/extras", { params: paramsObject }).then(({ data }) => {
            resolve(data.data);
        }).catch(({ response }) => {
            resolve([]);
        })
    })
}
async function depositiveExtrasList(paramsObject = {}) {
    return await new Promise(resolve => {
        ApiService.getParams("admin/depositive-products", { params: paramsObject }).then(({ data }) => {
            resolve(data);
        }).catch(({ response }) => {
            resolve([]);
        })
    })
}

async function getExtra(paramsObject = {}) {
    return await new Promise(resolve => {
        ApiService.getParams("admin/extra", { params: paramsObject }).then(({ data }) => {
            resolve(data.data);
        }).catch(({ response }) => {
            resolve(null);
        })
    })
}

async function countryList(paramsObject = {}) {
    return await new Promise(resolve => {
        ApiService.getParams("admin/country", { params: paramsObject }).then(({ data }) => {
            resolve(data);
        }).catch(({ response }) => {
            resolve([]);
        })
    })
}

async function depositiveCarClass(paramsObject = {}) {
    return await new Promise(resolve => {
        ApiService.getParams("admin/depositive-car-classes", { params: paramsObject }).then(({ data }) => {
            resolve(data.data);
        }).catch(({ response }) => {
            resolve([]);
        })
    })
}

async function subscription(paramsObject = {}) {
    return await new Promise(resolve => {
        ApiService.getParams("admin/subscription", { params: paramsObject }).then(({ data }) => {
            resolve(data.data);
        }).catch(({ response }) => {
            resolve(null);
        })
    })
}

async function subscriptionList(paramsObject = {}) {
    return await new Promise(resolve => {
        ApiService.getParams("admin/subscriptions", { params: paramsObject }).then(({ data }) => {
            resolve(data.data);
        }).catch(({ response }) => {
            resolve([]);
        })
    })
}

async function productList(paramsObject = {}) {
    return await new Promise(resolve => {
        ApiService.getParams("admin/products", { params: paramsObject }).then(({ data }) => {
            resolve(data.data);
        }).catch(({ response }) => {
            resolve([]);
        })
    })
}

async function packageList(paramsObject = {}) {
    return await new Promise(resolve => {
        ApiService.getParams("admin/packages", { params: paramsObject }).then(({ data }) => {
            resolve(data.data);
        }).catch(({ response }) => {
            resolve([]);
        })
    })
}

async function moduleList() {
    // Cache'de varsa direkt döndür
    if (moduleListCache) {
        return moduleListCache;
    }

    // Eğer bir istek zaten devam ediyorsa, aynı promise'i döndür
    if (moduleListPromise) {
        return await moduleListPromise;
    }

    // Yeni istek başlat ve promise'i cache'le
    moduleListPromise = new Promise(resolve => {
        ApiService.getParams("admin/modules").then(({ data }) => {
            moduleListCache = data;
            moduleListPromise = null; // İstek tamamlandı, promise cache'i temizle
            resolve(data);
        }).catch(({ response }) => {
            moduleListCache = [];
            moduleListPromise = null; // Hata durumunda da temizle
            resolve([]);
        })
    });

    return await moduleListPromise;
}

async function getUserCount(paramsObject = {}) {

    paramsObject.onlyUserCount = true;

    return await new Promise(resolve => {
        ApiService.getParams("admin/users", { params: paramsObject }).then(({ data }) => {
            resolve(data.data.userCount)
        }).catch(({ response }) => {
            resolve(0)
        })
    })
}

async function invoiceList(paramsObject = {}) {
    return await new Promise(resolve => {
        ApiService.getParams("admin/invoices", { params: paramsObject }).then(({ data }) => {
            resolve(data.data)
        }).catch(({ response }) => {
            resolve([])
        })
    })
}

// async versiyon - cache oluşturur, template'lerde kullanılamaz.
async function moduleControl(authName) {
    // Cache kontrolü
    if (moduleControlCache.hasOwnProperty(authName)) {
        return moduleControlCache[authName];
    }

    try {
        /* if (!store.getters.currentUser?.data?.companyId?.subscription) {
            moduleControlCache[authName] = false;
            return false;
        } */

        const modules = await moduleList();
        let result = false; // Varsayılan olarak false (erişim yok)

        if (modules.length > 0) {
            // Hem yeni yapıyı (packageId) hem eski yapıyı (product.metadata) destekliyoruz
            const sub = store.getters.currentUser?.data?.companyId?.subscription;
            let subscriptionModules = [];

            if (sub?.packageId?.modules) {
                // Yeni Yapı
                subscriptionModules = sub.packageId.modules;
            } else if (sub?.product?.metadata?.modules) {
                // Eski Yapı
                subscriptionModules = sub.product.metadata.modules.split(",");
            }

            // Modül listesinde bu authName varsa kontrol et
            if (modules.filter(module => authName === module.slug).length > 0) {
                // Subscription modüllerinde varsa ve iptal edilmemişse erişim var
                if (subscriptionModules.includes(authName) && sub?.status !== "canceled") {
                    result = true;
                }
            } else {
                // Modül listesinde yoksa (genel erişim)
                result = true;
            }
        }

        moduleControlCache[authName] = result;
        return result;

    } catch (error) {
        console.error('Module control error:', error);
        moduleControlCache[authName] = false; // Hata durumunda güvenli taraf: erişim yok
        return false;
    }
}

// Senkron versiyon - cache'den okur, template'lerde kullanılabilir
function moduleControlSync(authName) {
    // Cache'de varsa direkt döndür
    if (moduleControlCache.hasOwnProperty(authName)) {
        return moduleControlCache[authName];
    }

    // Cache'de yoksa arkaplanda yükle (await etmeden)
    moduleControl(authName);

    // İlk çağrıda false döndür (güvenli taraf)
    return false;
}

// Cache'i temizlemek için yeni fonksiyon
function clearModuleCache() {
    moduleListCache = null;
    moduleControlCache = {};
    moduleListPromise = null; // Promise cache'i de temizle
}

function subscriptionEmptyControl() {
    const sub = store.getters.currentUser?.data?.companyId?.subscription;
    if (sub?.packageId || sub?.product) {
        return true;
    }
    return false;
}

async function webhookDatas(paramsObject = {}) {
    return await new Promise(resolve => {
        ApiService.getParams("admin/webhook-logs", { params: paramsObject }).then(({ data }) => {
            resolve(data.data)
        }).catch(({ response }) => {
            resolve([])
        })
    })
}

const previewSrcList = ((imageList, key = 'url') => {
    return imageList?.map(img => {
        if (img?.url) {
            return img.url
        } else if (img[key]) {
            return img[key]
        } else {
            return img.thumbUrl
        }
    });
})

async function rentsysHgs(paramsObject = {}) {
    return await new Promise(resolve => {
        ApiService.post("admin/vehicle/hgs", paramsObject).then(({ data }) => {
            resolve(data.data)
        }).catch(({ response }) => {
            resolve([])
        })
    })
}

async function accidentReportTypeList(paramsObject = {}) {
    return await new Promise(resolve => {
        ApiService.getParams("admin/accident-report-types", { params: paramsObject }).then(({ data }) => {
            resolve(data.data)
        }).catch(({ response }) => {
            resolve([])
        })
    })
}

async function periodicMaintenanceList(paramsObject = {}) {
    return await new Promise(resolve => {
        ApiService.getParams("admin/periodic-maintenance", { params: paramsObject }).then(({ data }) => {
            resolve(data)
        }).catch(({ response }) => {
            resolve([])
        })
    })
}

async function accidentReportDocumentList(paramsObject = {}) {
    return await new Promise(resolve => {
        ApiService.getParams("admin/accident-report-documents", { params: paramsObject }).then(({ data }) => {
            resolve(data.data)
        }).catch(({ response }) => {
            resolve([])
        })
    })
}

const flattenObject = (obj, prefix = '') => {
    let result = {};

    for (const key in obj) {
        if (typeof obj[key] === 'object' && obj[key] !== null && !Array.isArray(obj[key])) {
            const nestedObj = flattenObject(obj[key], prefix ? `${prefix}.${key}` : key);
            result = { ...result, ...nestedObj };
        } else {
            const finalKey = prefix ? `${prefix}.${key}` : key;
            result[finalKey] = obj[key];
        }
    }

    return result;
}

async function transferTypeList(paramsObject = {}) {
    return await new Promise(resolve => {
        ApiService.getParams("admin/transfer-type", { params: paramsObject }).then(({ data }) => {
            resolve(data)
        }).catch(({ response }) => {
            resolve([])
        })
    })
}

async function serviceNameList(serviceName) {
    return await new Promise(resolve => {
        ApiService.getParams("admin/service-names", { params: { serviceName: serviceName } }).then(({ data }) => {
            resolve(data)
        }).catch((error) => {
            resolve([])
        })
    })
}

async function cleanStatusList(paramsObject = {}) {
    return await new Promise(resolve => {
        ApiService.getParams("admin/dirty-clean", { params: paramsObject }).then(({ data }) => {
            resolve(data)
        }).catch(({ response }) => {
            resolve([])
        })
    })
}

async function washingLists(paramsObject = {}) {
    return await new Promise(resolve => {
        ApiService.getParams("admin/washings", { params: paramsObject }).then(({ data }) => {
            resolve(lodash.orderBy(data.data, ["_id"], ["desc"]))
        }).catch(({ response }) => {
            resolve([])
        })
    })
}

async function washingStatusList(paramsObject = {}) {
    return await new Promise(resolve => {
        ApiService.getParams("admin/washing-status", { params: paramsObject }).then(({ data }) => {
            resolve(data)
        }).catch(({ response }) => {
            resolve([])
        })
    })
}

async function reflectStatusList(paramsObject = {}) {
    return await new Promise(resolve => {
        ApiService.getParams("admin/reflect-status", { params: paramsObject }).then(({ data }) => {
            resolve(data)
        }).catch(({ response }) => {
            resolve([])
        })
    })
}

async function washingCategoryList(paramsObject = {}) {
    return await new Promise(resolve => {
        ApiService.getParams("admin/washing-categories", { params: paramsObject }).then(({ data }) => {
            resolve(data.data)
        }).catch(({ response }) => {
            resolve([])
        })
    })
}

async function washingCompanyNameList(paramsObject = {}) {
    return await new Promise(resolve => {
        ApiService.getParams("admin/washing-company-names", { params: paramsObject }).then(({ data }) => {
            resolve(data)
        }).catch((error) => {
            resolve([])
        })
    })
}

async function vehicleDocumentList(paramsObject = {}) {
    return await new Promise(resolve => {
        ApiService.post("admin/vehicle/documents", paramsObject).then(({ data }) => {
            resolve(lodash.orderBy(data.data, ['createdAt', 'contractNumber'], ['asc']))
        }).catch(({ response }) => {
            resolve([])
        })
    })
}

async function deliveryCompensationClaims(paramsObject = {}) {
    return await new Promise(resolve => {
        ApiService.getParams("admin/delivery/compensation-claim-list", { params: paramsObject }).then(({ data }) => {
            resolve(lodash.orderBy(data.data, ["createdAt"], ["asc"]));
        }).catch(({ response }) => {
            resolve([]);
        })
    })
}

async function invoices(paramsObject = {}) {
    return await new Promise(resolve => {
        ApiService.getParams("admin/delivery/invoices", { params: paramsObject }).then(({ data }) => {
            resolve(data.data);
        }).catch(({ response }) => {
            resolve([]);
        })
    })
}

async function invoicesPdf(paramsObject = {}) {
    return await new Promise(resolve => {
        ApiService.getParams("admin/delivery/invoices/pdf", { params: paramsObject }).then(({ data }) => {
            resolve(data);
        }).catch(({ response }) => {
            resolve("");
        })
    })
}

async function washingCancelOptions(paramsObject = {}) {
    return await new Promise(resolve => {
        ApiService.getParams("admin/washing-cancel-options", { params: paramsObject }).then(({ data }) => {
            resolve(data.data);
        }).catch(({ response }) => {
            resolve([]);
        })
    })
}


async function notesList(paramsObject = {}) {
    return await new Promise(resolve => {
        ApiService.getParams("admin/notes", { params: paramsObject }).then(({ data }) => {
            resolve(data.data);
        }).catch(({ response }) => {
            resolve([]);
        })
    })
}


async function populateDamageData(damageLists) {
    // Hasar kayıtlarının içerisindeki user ve delivery alanı _id tipinde
    // bu alanları populate ederek object yapıyoruz ve user alanı için firstName,lastName delivery alanı için ise contractNumber bilgileri bulunuyor.
    // !!!!! Hasar kayıtları listelenirken oluşturan personelin kim olduğu ve sözleşme numarasının gösterilebilmesi için yapılıyor.
    if (damageLists.length > 0) {
        let ids = damageLists.map(item => item._id);
        let fetchedList = await damageList({
            _id: ids,
            select: "user",
            populate: [
                { path: 'user', select: '_id firstName lastName' },
                { path: 'delivery', select: '_id contractNumber' }
            ]
        });
        for (const item of damageLists) {
            const damageData = fetchedList.find(fu => fu._id === item._id);
            if (damageData && damageData.user) item.user = damageData.user;
            if (damageData && damageData.delivery) item.delivery = damageData.delivery;
        }
    }
}

async function updateDamageDatas(damageList) {
    // Hasar kayıtlarının içerisinde user ve delivery alanı _id tipinde
    // populateDamageData fonksiyonu ile object olması sağlanıyor.
    // bu fonksiyon ile tekrar _id tipine dönderiyoruz.
    for await (const item of damageList) {
        if (item?.user?._id) item.user = item?.user?._id
        if (item?.delivery?._id) item.delivery = item?.delivery?._id
    }
}

function deliveryTypeAreaControl(typeList = [], selectedType = '', area = '') {
    if (typeList.length <= 0 || !selectedType || !area) return false;

    let find = typeList.find(e => e.title === selectedType);

    return find ? find[area] || false : false;
}

async function timezoneList() {
    return await new Promise(resolve => {
        ApiService.getParams("admin/timezone").then(({ data }) => {
            resolve(data)
        }).catch(({ response }) => {
            resolve([])
        })
    })
}

async function findeksQuery(paramsObject = {}) {
    return await new Promise(resolve => {
        ApiService.post("admin/findeks", paramsObject).then(({ data }) => {
            resolve(data)
        }).catch((error) => {
            resolve(error?.response?.data)
        })
    })
}

async function getFindeks(paramsObject = {}) {
    return await new Promise(resolve => {
        ApiService.getParams("admin/findeks", { params: paramsObject }).then(({ data }) => {
            resolve(data.data)
        }).catch((error) => {
            resolve(null)
        })
    })
}

async function findeksList(paramsObject = {}) {
    return await new Promise(resolve => {
        ApiService.getParams("admin/findeks-lists", { params: paramsObject }).then(({ data }) => {
            resolve(data.data)
        }).catch((error) => {
            resolve([])
        })
    })
}

async function gpsCompanyList() {
    return await new Promise(resolve => {
        ApiService.getParams("admin/gps-providers").then(({ data }) => {
            resolve(data);
        }).catch(({ response }) => {
            resolve([]);
        })
    })
}

async function gpsLicensePlate(paramsObject = {}) {
    return await new Promise(resolve => {
        ApiService.post("admin/gps-license-plate", paramsObject).then(({ data }) => {
            resolve(data);
        }).catch(({ response }) => {
            resolve([]);
        })
    })
}

async function gpsDetach(paramObject = {}) {
    return await new Promise(resolve => {
        ApiService.post("admin/gps-detach", paramObject).then(({ data }) => {
            resolve(data);
        }).catch(({ response }) => {
            resolve(null);
        })
    })
}

async function gpsAttach(paramObject = {}) {
    return await new Promise(resolve => {
        ApiService.post("admin/gps-attach", paramObject).then(({ data }) => {
            resolve(data);
        }).catch(({ response }) => {
            resolve(null);
        })
    })
}

async function getGpsOdometer(paramsObject = {}) {
    return await new Promise(resolve => {
        ApiService.post("admin/gps-odometer", paramsObject).then(({ data }) => {
            resolve(data);
        }).catch(({ response }) => {
            resolve(null);
        })
    })
}

export default {
    currencyList,
    findeksList,
    priceFormat,
    getFindeks,
    findeksQuery,
    timezoneList,
    deliveryTypeAreaControl,
    populateDamageData,
    notesList,
    reflectStatusList,
    invoicesPdf,
    invoices,
    deliveryCompensationClaims,
    vehicleDocumentList,
    washingCompanyNameList,
    washingCategoryList,
    washingStatusList,
    washingLists,
    serviceNameList,
    rentsysHgs,
    previewSrcList,
    depositiveExtrasList,
    webhookDatas,
    subscriptionEmptyControl,
    moduleControl,
    moduleControlSync,
    invoiceList,
    getUserCount,
    moduleList,
    productList,
    subscription,
    subscriptionList,
    depositiveCarClass,
    countryList,
    getExtra,
    extrasList,
    paymentList,
    paymentLists,
    listLocations,
    listUsers,
    fuelTypeList,
    fuelLevelList,
    vehicleLists,
    vehicleList,
    partDamageList,
    vehiclePartList,
    vehicleDamageSketch,
    vehiclePhotos,
    vehiclePartsPhotosList,
    deliveryContractLists,
    deliveryContractList,
    damagePhotoList,
    transmissionList,
    deliveryReturnTypeList,
    deliveryTypeList,
    mainContractControl,
    getAuthSchema,
    getAuthList,
    authControl,
    subsAuthControl,
    deliveryLists,
    deliveryList,
    serviceLists,
    serviceCancelOptions,
    serviceTypes,
    logList,
    fileList,
    convertBytes,
    dateDiff,
    dealerLists,
    damageList,
    clearModuleCache,
    accidentReportTypeList,
    periodicMaintenanceList,
    accidentReportDocumentList,
    flattenObject,
    transferTypeList,
    cleanStatusList,
    washingCancelOptions,
    getDamage,
    updateDamageDatas,
    gpsCompanyList,
    gpsLicensePlate,
    gpsAttach,
    gpsDetach,
    getGpsOdometer,
    packageList
}